import React, { useState, useEffect } from 'react';
import ClaimTabItem from 'app/modules/claim/ui/components/desktop/tab-items/claim-tab-item';
import Pagination from '@material-ui/lab/Pagination';
import usePagination from 'app/shared/components/desktop/pagination/pagination';
import { returnComponenet } from 'app/modules/contract/ui/tools/constants';
import './claim.scss';
import { useHistory, useLocation } from 'react-router';
import ConfComp from 'app/shared/components/common/conf-component';
import { useDispatch, useSelector } from 'react-redux';
import { getClaimsList, getClaimState, getFullClaimsList, getFullClaimsListMobile } from 'app/modules/claim/service/store/selectors';
import { getDataViewRules } from 'app/modules/rules/service/store/selectors';
import { IRootState } from 'app/shared/reducers';
import { getDesktopClaimFreeSelector, getMobileClaimFreeSelector } from 'app/modules/cms/service/store/selectors';
import { RulesContext } from 'app/modules/rules/domain/RulesContext';
import ContractEngineSkeleton from 'app/shared/components/skeleton/contract-engine/contract-engine';
import { RulesKeys } from 'app/modules/rules/domain/rules.keys';
import { View } from 'app/modules/rules/domain/View';
import { console } from 'fp-ts';
import { getDataView } from 'app/modules/rules/service/rulesService';
import ClaimListItem from 'app/modules/claim/ui/components/mobile/mobile-claimlist-item';
import {
  getclaim,
  getClaimsClientsForActiveSubscription,
  getclaimsListBySubscriptionNumber,
  getclaimsListBySubscriptionNumberForContractDaitails,
  getClaimSubscription,
} from 'app/modules/claim/service';
import { getDocCMS } from 'app/modules/cms/service/cmsService';
import Loader from 'app/shared/components/spb/loader/loader';

export const ClaimListPage = ({
  data = [],
  listPage = 1,
  setListPage,
  setValue,
  emptySearch,
  onInputChange,
  resetClaimsHandler,
  dataConf,
  criteria,
}) => {
  const resetClaims = () => {
    resetClaimsHandler();
    setValue('');
  };

  const dispatch = useDispatch();
  const deviceType: any = useSelector<IRootState>(state => state.global?.deviceType || '');
  const rulesContext: RulesContext = {
    key: RulesKeys.GET_VIEW_DATA_CONFIGURATION,
    entryDataRules: { view: View.CLAIMS, deviceType },
  };

  const fullclaimsList: any = useSelector<IRootState>(getClaimsList);
  const claims: any = useSelector<IRootState>(state => state.claim.claimListForContract);
  const viewDataitems = useSelector(getDataViewRules(View.CLAIMS as any));
  const cmsContractAndClaimtStatus: any = useSelector<IRootState>(state => state.cms?.documents['desktop_contract_and_claim_status_v2']);
  const claimsFreeMobileCMS: any = useSelector(getMobileClaimFreeSelector);

  const claimLoading: boolean = useSelector<IRootState>(state => state.claim.loading) as boolean;
  const claimListPage: number = useSelector<IRootState>(state => state.claim.page) as number;
  const claimState: any = useSelector<IRootState>(getClaimState);
  const location: any = useLocation();
  const [currentList, setcurrentList] = useState([]);

  const [page, setPage] = useState(1);
  const PER_PAGE = 5;

  const count = Math.ceil(data.length / PER_PAGE);
  const _DATA = usePagination(fullclaimsList, PER_PAGE);

  useEffect(() => {
    if (location.state?.subNumber) {
      dispatch(getclaimsListBySubscriptionNumberForContractDaitails(location.state?.subNumber));
      
    } else {
      dispatch(getClaimsClientsForActiveSubscription());
          }
  }, [location.state?.subNumber]);

  useEffect(() => {
    dispatch(getDataView(rulesContext));
    dispatch(getDocCMS('desktop_contract_and_claim_status_v2'));
    dispatch(getDocCMS('mobile_claim_customer_v2'));
  }, []);

  useEffect(() => {
    _DATA.jump(listPage);
  }, [listPage, _DATA]);

  const handleChange = (e, p) => {
    setPage(p);
    setListPage(p);
  };

  return (
    <>
      {claimLoading ? (
        <Loader />
      ) : (
        <div className="claim-list">
          {dataConf?.componentDataList?.find(e => e.componentDataKey === 'CLAIM_PDV_ROW') && (
            <div className="resultat_style d-flex justify-content-between mb-4">{`${data.length} résultat${
              data.length <= 1 ? '' : 's'
            }`}</div>
          )}

          <div className="resultat_style d-flex justify-content-between font-weight-bold mb-2 ml-3">
            <p>{fullclaimsList?.length > 1 ? claimsFreeMobileCMS?.claims_label : claimsFreeMobileCMS?.claims_label_singular}</p>
          </div>

          {viewDataitems?.componentDataList?.find(e => e.componentDataKey === 'CLAIM_LIST_ROW') &&
            (fullclaimsList || []).map((item, index) => {
              return (
                <div key={index} className="m-3">
                  <ConfComp
                    code="CLAIM_LIST_ROW"
                    listCode={viewDataitems?.componentDataList}
                    props={{
                      item,
                      dataConf: viewDataitems?.componentDataList || [],
                      claimsFreeMobileCMS,
                      cmsContractAndClaimtStatus,
                    }}
                  />
                </div>
              );
            })}
        </div>
      )}
    </>
  );
};
